import { isEmpty } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { COMPARE_FILTER_TYPE_SIGN } from "../../utils/constants";
import { longDateTime } from "../../utils/DateHelper";
import ProductTags from "../Tags/ProductTags";
import InformationTooltip from "../Tooltips/InformationTooltip";

const ScanFilterApplied = ({
    appliedFilter,
    enableEditFilter,
    getIsOutlierValue,
}) => {
    const {
        material,
        lots,
        models,
        createdByUsers,
        devices,
        suppliers,
        onBehalfOf,
        isOutlier,
        threshold,
        sampleName,
        note,
        capturedStartDate,
        capturedEndDate,
    } = appliedFilter;
    const { t } = useTranslation();

    const getThresholdTags = () => {
        const thresholdTags = [];
        threshold?.filters?.forEach((filter, index) => {
            thresholdTags.push(
                <span>
                    {filter.target} ({filter.unit?.displayUnit || filter.unit})
                    <span className="mx-2 text-xs text-primary-color-orange">
                        {COMPARE_FILTER_TYPE_SIGN[filter.compare]}
                    </span>{" "}
                    {filter.value}
                </span>
            );
            if (threshold?.filters?.length !== index + 1)
                thresholdTags.push(t(threshold?.type));
        });
        return thresholdTags;
    };

    const appliedFilters = [
        {
            title: t("material"),
            tags: [material],
            condition: true,
        },
        {
            title: `${t("capture")} - ${t("startDate")}`,
            tags: [longDateTime(new Date(capturedStartDate))],
            condition: capturedStartDate,
        },
        {
            title: `${t("capture")} - ${t("endDate")}`,
            tags: [longDateTime(new Date(capturedEndDate))],
            condition: capturedEndDate,
        },
        {
            title: t("models"),
            tags: models,
            condition: !isEmpty(models),
        },
        {
            title: t("lots"),
            tags: lots,
            condition: !isEmpty(lots),
        },
        {
            title: t("devices"),
            tags: devices,
            condition: !isEmpty(devices),
        },
        {
            title: t("suppliers"),
            tags: suppliers,
            condition: !isEmpty(suppliers),
        },
        {
            title: t("createdBy"),
            tags: createdByUsers,
            condition: !isEmpty(createdByUsers),
        },
        {
            title: t("onBehalfOf"),
            tags: onBehalfOf,
            condition: !isEmpty(onBehalfOf),
        },
        {
            title: t("sampleName"),
            tags: [sampleName],
            condition: sampleName,
        },
        {
            title: t("note"),
            tags: [note],
            condition: note,
        },
        {
            title: t("threshold"),
            tags: getThresholdTags() || [],
            condition: threshold,
        },
        {
            title: t("markedAsOutlier"),
            tags: [getIsOutlierValue(isOutlier)?.toString()],
            condition:
                isOutlier?.toString() === "true" ||
                isOutlier?.toString() === "false",
        },
    ];

    return (
        <>
            <div className="flex items-center justify-between">
                <header className="flex items-center">
                    <h4 className="text-primary-blue ">
                        {t("appliedFilters")}
                    </h4>
                    <InformationTooltip
                        message={t("recentFiltersInfo")}
                        className="ml-2 tiny"
                    />
                </header>
                <div className="main-customer-form-bnt flex items-center justify-end">
                    <button
                        className="secondary-green-btn mng-model modal-btn-open ml-2"
                        onClick={enableEditFilter}
                    >
                        <i className="fas fa-edit mr-2"></i>
                        {t("editFilter")}
                    </button>
                </div>
            </div>
            <hr className="my-2" />
            <div className="grid grid-cols-2 gap-2">
                {appliedFilters.map((filter) => {
                    if (filter.condition) {
                        return (
                            <div key={filter.title}>
                                <label className="uppercase">
                                    {filter.title}
                                </label>
                                <ProductTags tags={filter.tags} />
                            </div>
                        );
                    }
                })}
            </div>
        </>
    );
};

export default ScanFilterApplied;
